<script setup lang="ts">
import type { DiscreteNumericListDto } from '@/api/generator';
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import type { DiscreteNumericListProps } from '@/components/forms/types.ts';
import { computed } from 'vue';

const props = defineProps<DiscreteNumericListProps>();

const emits = defineEmits<{
  'update:discreteNumericList': [input: DiscreteNumericListDto | undefined];
}>();

const selectOptions = computed(() => {
  return props.discreteNumericList?.availableValues?.map((value) => {
    return {
      title: `${value} ${props.discreteNumericList?.unitAbbreviation}`,
      value: value,
    };
  });
});

function onUpdate(input: number[] | undefined) {
  if (props.discreteNumericList) {
    emits('update:discreteNumericList', {
      ...props.discreteNumericList,
      selectedValues: input ? [...input].sort((a, b) => a - b) : undefined,
    });
  }
}
</script>

<template>
  <Autocomplete
    v-bind="props"
    :modelValue="discreteNumericList?.selectedValues"
    :items="selectOptions"
    clearable
    closableChips
    multiple
    chips
    @update:modelValue="onUpdate"
  />
</template>
